<template>
  <div class="row shaded thank-you">
    <div class="columns medium-12 text text-center">
      <header class="text-center">
        <h2>Thank you for Signing Up!</h2>
      </header>
      <p>
        Enjoy exploring our wines. If you ever need assistance, drop us a line
        at <CustomerServiceEmailLink />.
      </p>
    </div>
  </div>
</template>
